// extracted by mini-css-extract-plugin
export default {"privacyPolicyContainer":"privacyPolicy_privacyPolicyContainer__C-i8W"};